export default __webpack_public_path__ + "static/media/others.480fbc59.png";